var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4073 4.72596C12.3967 4.16947 13.6046 4.16947 14.594 4.72596L20.0107 7.7728C21.034 8.34844 21.6673 9.43129 21.6673 10.6054V16.5539C21.6673 17.728 21.034 18.8109 20.0107 19.3865L14.5939 22.4334C13.6046 22.9899 12.3967 22.9899 11.4074 22.4334L5.99074 19.3868C4.96733 18.8113 4.33398 17.7284 4.33398 16.5541V10.6054C4.33398 9.43127 4.96729 8.34841 5.99066 7.77278L11.4073 4.72596Z",
    stroke: "currentColor",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 13.5801C16.25 15.375 14.795 16.8301 13 16.8301C11.2051 16.8301 9.75003 15.375 9.75003 13.5801C9.75003 11.7851 11.2051 10.3301 13 10.3301C14.795 10.3301 16.25 11.7851 16.25 13.5801Z",
    stroke: "currentColor",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillSettings);
export default __webpack_public_path__ + "static/media/bill-settings.1774bb7742d50ae60bf44197acc96d07.svg";
export { ForwardRef as ReactComponent };